import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorValidation } from '@/store/targetAccumulator/selectors.ts';

const LeverageRatio = () => {
  const tileId = useTargetAccumulatorTileId();
  const leverage = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.leverage);
  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleLeverage = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Leverage ratio changed',
      isDefined(value) ? String(value) : 'null',
    );

    return checkTargetAccumulatorWithTradeCapture({
      leverage: isDefined(value) ? value : null,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.leverage">
      <TradeCaptureValidationWrapper validation={validation?.leverage}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          value={leverage}
          allowNegative={false}
          maxDecimals={9}
          onChange={handleLeverage}
          size="sm"
          data-e2e="leverage-ratio"
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default LeverageRatio;
